import styled from 'styled-components';
import {JackpotAmountDefaultBox} from './jackpot-amount.default.box';


export const JackpotAmountCasino777Box = styled(JackpotAmountDefaultBox)`
    color: ${props => props.theme.colors.dangerLight};
    font-weight: 600;
    font-family: ${({theme}) => theme.font.family.bold};
    font-size: 1.4rem;

    @media ${({theme}) => theme.mediaQuery.mAndAbove} {
        font-size: 1.4rem;
        top: 2rem;
    }
    
    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
      font-size: 1.2rem;
    }
`